import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PAGE_FIX_EVENT } from '@client/app/modules/page-fix/constants/page-fix-event';
import { PAGE_FIX_FORM_VIEW_NAME } from '@client/app/modules/page-fix/constants/page-fix-form-view-name';
import { PAGE_FIX_FORM_VIEW_TYPE } from '@client/app/modules/page-fix/constants/page-fix-form-view-type';
import { PAGE_FIX_FORM_FOOTER } from '@client/app/modules/page-fix/constants/page-fix-form-footer';

@Component({
    selector: 'page-fix-form-italic',
    templateUrl: './page-fix-form-italic.component.html',
    standalone: false,
})
export class PageFixFormItalicComponent implements OnInit, OnDestroy {
    @Input() resolve!: any;
    @Output() close = new EventEmitter();
    @Output() dismiss = new EventEmitter();

    goToViewId: number = 0;
    customValidationId: number = 0;
    pageFix: any;
    pageFixId: number = 0;
    pageFixSelector: string = '';
    customValidation: boolean = true;
    infoViewName: string = '';
    infoViewType: string = '';
    infoFooter: string = '';
    optionsViewName: string = '';
    optionsViewType: string = '';
    optionsFooter: string = '';
    testingViewName: string = '';
    testingViewType: string = '';
    testingFooter: string = '';

    constructor (private monEventService: MonEventService) {}

    ngOnInit (): void {
        this.activate();
    }

    ngOnDestroy (): void {
        this.onDestroy();
    }

    private activate (): void {
        this.goToViewId = 0;
        this.pageFix = this.resolve.pageFix;
        this.pageFixId = this.resolve.typeId || this.resolve.model.id;
        this.pageFixSelector = JSON.stringify(['i']);
        this.customValidation = true;
        this.infoViewName = PAGE_FIX_FORM_VIEW_NAME.INFO;
        this.infoViewType = PAGE_FIX_FORM_VIEW_TYPE.INFO;
        this.infoFooter = PAGE_FIX_FORM_FOOTER.GO_TO;
        this.optionsViewName = PAGE_FIX_FORM_VIEW_NAME.OPTIONS;
        this.optionsViewType = PAGE_FIX_FORM_VIEW_TYPE.OPTIONS;
        this.optionsFooter = PAGE_FIX_FORM_FOOTER.SUBMIT;
        this.testingViewName = PAGE_FIX_FORM_VIEW_NAME.TESTING;
        this.testingViewType = PAGE_FIX_FORM_VIEW_TYPE.TESTING;
        this.testingFooter = PAGE_FIX_FORM_FOOTER.GO_TO;

        this.setupListeners();
    }

    private onDestroy (): void {
        this.monEventService.remove(this.goToViewId);
        this.monEventService.remove(this.customValidationId);
    }

    private setupListeners (): void {
        this.goToViewId = this.monEventService.addListener(PAGE_FIX_EVENT.FORM_REQUEST_GO_TO_VIEW, () => {
            this.setView(PAGE_FIX_FORM_VIEW_NAME.OPTIONS);
        });
        this.customValidationId = this.monEventService.addListener(PAGE_FIX_EVENT.CUSTOM_VALIDATION, (isValid: boolean) => {
            this.customValidation = isValid;
        });
    }

    private setView (viewName: string): void {
        this.monEventService.run(PAGE_FIX_EVENT.FORM_UPDATE_VIEW, viewName);
    }

    closeModal (pageFix: any): void {
        this.close.emit({ $value: pageFix });
    }
}
